import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import PropTypes from "prop-types";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonSwal from "../../../components/Swal/commonSwal";
import TabContent from "../../../components/Tab/TabContent";
import StepsList from "../../../components/steps/StepsList";
import StepsButton from "../../../components/steps/StepsButton";
import TabPane from "../../../components/Tab/TabPane";
import CommonInput from "../../../components/forms/CommonInput";
import {
  handleChange,
  handleChangeFile,
  handleChangeNameValue,
  handleChangeNumeral,
  handleChangeUnmask,
} from "../../../helpers/handleFormChanges";
import CommonInputMask from "../../../components/forms/CommonInputMask";
import CommonInputFile from "../../../components/forms/CommonInputFile";
import TabHelper from "../../../helpers/TabHelper";
import CommonInputDate from "../../../components/forms/CommonInputDate";
import CommonSelect from "../../../components/forms/CommonSelect";
import CommonRadioOpcoes from "../../../components/forms/CommonRadioOpcoes";

const DadosPessoaisTab = ({
  values,
  setValues,
  estados,
  municipios,
  tiposEstadoCivil,
  tiposRegimeBens,
}) => (
  <TabPane id="dadosPessoais" ativo>
    <div className="row">
      <div className="col-lg-7 mb-3">
        <CommonInput
          label="Nome completo"
          id="nome"
          value={values.nome}
          onChange={(e) => handleChange(e, values, setValues)}
          required
        />
      </div>
      <div className="col-lg-3 mb-3">
        <CommonInputMask
          mask="999.999.999-99"
          label="CPF"
          id="cpf"
          value={values.cpf}
          onChange={(e) => handleChangeUnmask(e, values, setValues)}
          required
        />
      </div>
      <div className="col-lg-2 mb-3">
        <CommonInput
          label="RG"
          id="identidade_numero"
          value={values.identidade_numero}
          onChange={(e) => handleChangeUnmask(e, values, setValues)}
          required
        />
      </div>
    </div>
    <div className="row">
      <div className="col-lg-3 mb-3">
        <CommonInput
          label="Órgão expedidor do RG"
          id="expedidor_rg"
          value={values.expedidor_rg}
          onChange={(e) => handleChange(e, values, setValues)}
          maxlength="5"
          required
        />
      </div>
      <div className="col-lg-2 mb-3">
        <CommonInputMask
          mask="99.99999.99-9"
          label="Número do PIS"
          id="pis"
          value={values.pis}
          onChange={(e) => handleChangeUnmask(e, values, setValues)}
        />
      </div>
      <div className="col-lg-5 mb-3">
        <CommonInput
          label="Profissão"
          id="profissao"
          value={values.profissao}
          onChange={(e) => handleChange(e, values, setValues)}
          required
        />
      </div>
      <div className="col-lg-2 mb-3">
        <CommonInputDate
          label="Data de nascimento"
          id="data_nascimento"
          value={values.data_nascimento}
          onChange={(e) => {
            handleChange(e, values, setValues);
          }}
          required
        />
      </div>
    </div>
    <div className="row">
      <div className="col-lg-2 mb-3">
        <CommonSelect
          label="UF de nascimento"
          id="estado"
          value={values.estadoId}
          onChange={(e) => {
            const selectedEstadoId = e.target.value;
            const selectedEstadoName =
              e.target.options[e.target.selectedIndex]?.text;
            const opcaoSelecionada = e.target.options[e.target.selectedIndex];
            const selectedEstadoSigla = opcaoSelecionada?.dataset?.uf;

            setValues((prevValues) => ({
              ...prevValues,
              estado: selectedEstadoName,
              estadoId: selectedEstadoId,
              uf_nascimento: selectedEstadoSigla,
            }));
          }}
          data={
            estados &&
            Object.keys(estados).map((estadoKey) => ({
              text: estados[estadoKey].nome,
              id: estados[estadoKey].id,
              "data-uf": estados[estadoKey].sigla,
            }))
          }
          placeholder="Selecione o estado"
          required
        />
      </div>
      <div className="col-lg-3 mb-3">
        <CommonSelect
          label="Município"
          id="cidade_nascimento"
          value={values.cidade_nascimento}
          onChange={(e) => {
            handleChange(e, values, setValues);
          }}
          data={
            municipios &&
            Object.keys(municipios).map((estadoKey) => ({
              text: municipios[estadoKey].nome,
              id: municipios[estadoKey].nome,
            }))
          }
          placeholder="Selecione o município"
          required
        />
      </div>
      <div className="col-lg-5 mb-3">
        <CommonInput
          label="E-mail"
          id="email"
          value={values.email}
          onChange={(e) => handleChange(e, values, setValues)}
          required
        />
      </div>
      <div className="col-lg-2 mb-3">
        <CommonInputMask
          mask="(99) 99999-9999"
          label="Celular"
          id="celular"
          value={values.celular}
          onChange={(e) => handleChangeUnmask(e, values, setValues)}
          required
        />
      </div>
    </div>
    <div className="row">
      <div className="col-lg-3">
        <CommonSelect
          id="estado_civil"
          label="Estado civil"
          onChange={(e) => handleChange(e, values, setValues)}
          value={values.estado_civil}
          data={tiposEstadoCivil.map((estadoCivil) => ({
            text: estadoCivil.valor,
            id: estadoCivil.chave,
          }))}
          required
          placeholder="Selecione"
        />
      </div>
      <div className="col-lg-2">
        <CommonRadioOpcoes
          label="Sócio responsável?"
          hint="Sócio responsável perante a Receita Federal pela empresa."
          hintIcon="question"
          id="adm_responsavel"
          upValue={!values.adm_responsavel}
          lowValue={values.adm_responsavel}
          upOnChange={(e) =>
            handleChangeNameValue(
              "adm_responsavel",
              !e.target.checked,
              values,
              setValues
            )
          }
          lowOnChange={(e) =>
            handleChangeNameValue(
              "adm_responsavel",
              e.target.checked,
              values,
              setValues
            )
          }
          upText="Não"
          lowText="Sim"
        />
      </div>

      {parseInt(values?.estado_civil) === 2 && (
        <div className="col-lg-3">
          <CommonSelect
            id="regime_bens"
            label="Regime de bens"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.regime_bens}
            data={tiposRegimeBens.map((regimeBens) => ({
              text: regimeBens.valor,
              id: regimeBens.chave,
            }))}
            required
          />
        </div>
      )}
    </div>
  </TabPane>
);

const EnderecoTab = ({ values, setValues }) => (
  <TabPane id="enderecoSocio">
    <div className="row">
      <div className="col-lg-3 mb-3">
        <CommonInputMask
          mask="99999-999"
          label="CEP"
          id="cep"
          value={values.cep}
          onChange={(e) => handleChangeUnmask(e, values, setValues)}
          required
        />
      </div>
      <div className="col-lg-5 mb-3">
        <CommonInput
          label="Logradouro"
          id="logradouro"
          value={values.logradouro}
          onChange={(e) => handleChange(e, values, setValues)}
          required
        />
      </div>
      <div className="col-lg-1 mb-3">
        <CommonInput
          label="N°"
          id="numero"
          value={values.numero}
          onChange={(e) => handleChangeNumeral(e, values, setValues)}
          required
        />
      </div>
      <div className="col-lg-3 mb-3">
        <CommonInput
          label="Complemento"
          id="compl"
          value={values.compl}
          onChange={(e) => handleChange(e, values, setValues)}
        />
      </div>
    </div>
    <div className="row">
      <div className="col-lg-4 mb-3">
        <CommonInput
          label="Bairro"
          id="bairro"
          value={values.bairro}
          onChange={(e) => handleChange(e, values, setValues)}
          required
        />
      </div>
      <div className="col-lg-4 mb-3">
        <CommonInput
          label="Cidade"
          id="cidade"
          value={values.cidade}
          onChange={(e) => handleChange(e, values, setValues)}
          required
          disabled
        />
      </div>
      <div className="col-lg-1 mb-3">
        <CommonInput
          label="UF"
          id="uf"
          value={values.uf}
          onChange={(e) => handleChange(e, values, setValues)}
          required
          disabled
        />
      </div>
    </div>
  </TabPane>
);

const DocumentosTab = ({ values, setValues, downloadDocumento }) => (
  <TabPane id="documentos">
    <div className="row align-items-center">
      <div className="col-md-6 mb-3">
        <label className="form-label requiredInput">
          CNH (caso não tenha, favor adicionar RG)
        </label>
      </div>
      <div className="col-md-6 mb-3">
        {values?.identidade ? (
          <>
            <CommonButton
              color="info"
              onClick={() => {
                downloadDocumento(values?.identidade, values?.identidade_ext);
              }}
              style={{ marginRight: ".25rem" }}
            >
              <i className="mdi mdi-cloud-download d-block font-size-18"></i>
            </CommonButton>
            <CommonButton
              color="danger"
              onClick={() => {
                setValues((prevValues) => ({
                  ...prevValues,
                  identidade: null,
                }));
              }}
            >
              <i className="mdi mdi-trash-can d-block font-size-18"></i>
            </CommonButton>
          </>
        ) : (
          <CommonInputFile
            label="Selecione o arquivo"
            accept="application/pdf"
            id="identidade"
            onChange={(e) => handleChangeFile(e, values, setValues)}
            required
            data-arquivo="1"
          />
        )}
      </div>
    </div>
    <div className="row align-items-center">
      <div className="col-md-6 mb-3">
        <label className="form-label requiredInput">
          Título de eleitor ou último recibo IR
        </label>
      </div>
      <div className="col-md-6 mb-3">
        {values?.titulo_eleitor ? (
          <>
            <CommonButton
              color="info"
              onClick={() => {
                downloadDocumento(
                  values?.titulo_eleitor,
                  values?.titulo_eleitor_ext
                );
              }}
              style={{ marginRight: ".25rem" }}
            >
              <i className="mdi mdi-cloud-download d-block font-size-18"></i>
            </CommonButton>
            <CommonButton
              color="danger"
              onClick={() => {
                setValues((prevValues) => ({
                  ...prevValues,
                  titulo_eleitor: null,
                }));
              }}
            >
              <i className="mdi mdi-trash-can d-block font-size-18"></i>
            </CommonButton>
          </>
        ) : (
          <CommonInputFile
            label="Selecione o arquivo"
            accept="application/pdf"
            id="titulo_eleitor"
            onChange={(e) => handleChangeFile(e, values, setValues)}
            required
            data-arquivo="1"
          />
        )}
      </div>
    </div>
  </TabPane>
);

function SocioMigracaoModal({
  modalHook,
  valuesHook,
  cepApi,
  salvarProcesso,
  tabHook,
  downloadDocumento,
  estados,
  municipios,
  tiposEstadoCivil,
  tiposRegimeBens,
}) {
  const { values, setValues } = valuesHook;
  const { socioMigracaoModal, setSocioMigracaoModal } = modalHook;
  const { getCep, cepResponse } = cepApi;
  const { tabAtual, setTabAtual } = tabHook;

  //Busca dados do CEP
  React.useEffect(() => {
    if (!values?.cep || values?.cep.length !== 8) return;
    try {
      getCep(values.cep);
    } catch (e) {
      CommonSwal({
        title: "Oops!",
        text: "Ocorreu algum erro inesperado, se o problema persistir entre em contato com o suporte Orangiuz",
        icon: "error",
      });
    }
  }, [getCep, values.cep]);

  //Define o retorno da api nos valores dos campos
  React.useEffect(() => {
    if (!cepResponse) return;
    setValues((values) => ({
      ...values,
      logradouro: cepResponse.logradouro,
      bairro: cepResponse.bairro,
      cidade: cepResponse.localidade,
      uf: cepResponse.uf,
      codigo_cidade: cepResponse.ibge,
    }));
  }, [cepResponse, setValues]);

  return (
    <CommonModal
      title="Cadastro de sócio"
      is_open_modal={socioMigracaoModal}
      set_is_open_modal={setSocioMigracaoModal}
      size="xl"
      customFooter={
        <div className="modal-footer justify-content-between">
          <div>
            {tabAtual > 0 && (
              <CommonButton
                onClick={() => {
                  TabHelper.trocarTab(tabAtual, setTabAtual, -1);
                }}
                color="primary"
              >
                Anterior
              </CommonButton>
            )}
          </div>
          <div>
            <CommonButton
              color="success"
              onClick={salvarProcesso}
              style={{ marginRight: "0.25rem" }}
            >
              Salvar
            </CommonButton>
            <CommonButton
              onClick={() => {
                setSocioMigracaoModal(false);
              }}
              color="danger"
              style={{ marginRight: "0.25rem" }}
            >
              Cancelar
            </CommonButton>
            {tabAtual < 2 && (
              <CommonButton
                onClick={() => {
                  TabHelper.trocarTab(tabAtual, setTabAtual, 1);
                }}
                color="primary"
              >
                Próximo
              </CommonButton>
            )}
          </div>
        </div>
      }
    >
      <StepsList>
        <StepsButton
          href="dadosPessoais"
          onClick={() => {
            setTabAtual(0);
          }}
          step={1}
          ativo
        >
          Dados pessoais
        </StepsButton>
        <StepsButton
          href="enderecoSocio"
          onClick={() => {
            setTabAtual(1);
          }}
          step={2}
        >
          Endereço do sócio
        </StepsButton>
        <StepsButton
          href="documentos"
          onClick={() => {
            setTabAtual(2);
          }}
          step={3}
        >
          Documentos do sócio
        </StepsButton>
      </StepsList>
      <TabContent>
        <DadosPessoaisTab
          setValues={setValues}
          values={values}
          estados={estados}
          municipios={municipios}
          tiposEstadoCivil={tiposEstadoCivil}
          tiposRegimeBens={tiposRegimeBens}
        />
        <EnderecoTab setValues={setValues} values={values} />
        <DocumentosTab
          setValues={setValues}
          values={values}
          downloadDocumento={downloadDocumento}
        />
      </TabContent>
    </CommonModal>
  );
}

SocioMigracaoModal.propTypes = {
  modalHook: PropTypes.shape({
    socioMigracaoModal: PropTypes.bool.isRequired,
    setSocioMigracaoModal: PropTypes.func.isRequired,
  }).isRequired,
  tabHook: PropTypes.shape({
    tabAtual: PropTypes.bool.isRequired,
    setTabAtual: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  cepApi: PropTypes.shape({
    getCep: PropTypes.func.isRequired,
    cepResponse: PropTypes.object,
  }).isRequired,
  salvarProcesso: PropTypes.func.isRequired,
  downloadDocumento: PropTypes.func.isRequired,
  estados: PropTypes.array.isRequired,
  municipios: PropTypes.array.isRequired,
  tiposEstadoCivil: PropTypes.array.isRequired,
  tiposRegimeBens: PropTypes.array.isRequired,
};

DadosPessoaisTab.propTypes = {
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  estados: PropTypes.array.isRequired,
  municipios: PropTypes.array.isRequired,
  tiposEstadoCivil: PropTypes.array.isRequired,
  tiposRegimeBens: PropTypes.array.isRequired,
};

EnderecoTab.propTypes = {
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
};

DocumentosTab.propTypes = {
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  downloadDocumento: PropTypes.func.isRequired,
};

export default SocioMigracaoModal;
